import type { Article, StrapiResponse } from '../types/article';

const STRAPI_URL = import.meta.env.VITE_STRAPI_URL;
const API_TOKEN = import.meta.env.VITE_STRAPI_API_TOKEN;

const headers = {
  'Authorization': `Bearer ${API_TOKEN}`,
  'Content-Type': 'application/json',
};

export const strapiService = {
  /**
   * Fetch all articles
   */
  async getArticles(): Promise<Article[]> {
    try {
      const response = await fetch(`${STRAPI_URL}/api/articles?populate=*`, {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch articles: ${response.statusText}`);
      }

      const result: StrapiResponse<Article[]> = await response.json();
      return result.data;
    } catch (error) {
      console.error('Error fetching articles:', error);
      throw error;
    }
  },

  /**
   * Fetch a single article by ID
   */
  async getArticleById(id: string): Promise<Article> {
    try {
      const response = await fetch(`${STRAPI_URL}/api/articles/${id}?populate=*`, {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch article: ${response.statusText}`);
      }

      const result: StrapiResponse<Article> = await response.json();
      return result.data;
    } catch (error) {
      console.error('Error fetching article:', error);
      throw error;
    }
  },

  /**
   * Fetch a single article by slug
   */
  async getArticleBySlug(slug: string): Promise<Article | null> {
    try {
      const response = await fetch(`${STRAPI_URL}/api/articles?filters[slug][$eq]=${slug}&populate=*`, {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch article: ${response.statusText}`);
      }

      const result: StrapiResponse<Article[]> = await response.json();
      return result.data.length > 0 ? result.data[0] : null;
    } catch (error) {
      console.error('Error fetching article by slug:', error);
      throw error;
    }
  },

  /**
   * Get the full URL for a Strapi media file
   */
  getMediaUrl(url: string): string {
    if (url.startsWith('http')) {
      return url;
    }
    return `${STRAPI_URL}${url}`;
  },
};
